<template>
  <v-menu v-model="openEditTag" :close-on-content-click="false" left>
    <template v-slot:activator="{ on }">
      <mf-button color="cinza-d20" icon="edit" type="icon" size="sm" @click="openEditTag = true" />
    </template>
    <v-card>
      <v-container class="pa-4">
        <v-row>
          <v-col class="pt-0">
            <v-text-field ref="updateTagInput" v-model="tagName" outlined hide-details label="Nome do marcador" maxlength="30" @keyup.enter="updateTagName" />
          </v-col>
        </v-row>
        <v-row class="px-3">
          <mf-button class="mr-2" text color="vermelho-d20" label="Deletar" icon="delete" @click="emitDeleteTag" />
          <v-spacer />
          <mf-button label="Salvar" @click="emitUpdateTagName">Salvar</mf-button>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    tag: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data: () => ({
    openEditTag: false,
    tagName: '',
    tagOldName: '',
  }),
  computed: {
    tagList() {
      return this.$store.getters.tagList
    },
  },
  watch: {
    openEditTag(value) {
      if (!value) return
      this.tagName = this.tag.name
      this.tagOldName = this.tag.name
      setTimeout(() => {
        if (this.$refs.updateTagInput) {
          this.$refs.updateTagInput.$el.querySelector('input').select()
        }
      }, 200)
    },
  },
  methods: {
    emitDeleteTag() {
      this.openEditTag = false
      this.$emit('delete-tag', this.tag)
    },
    emitUpdateTagName() {
      if (!this.tagName || this.tagName === this.tagOldName) {
        this.openEditTag = false
        return
      }
      this.openEditTag = false
      this.$emit('update-tag-name', { oldName: this.tagOldName, newName: this.tagName, tag: this.tag })
    },
  },
}
</script>
